// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../types.schema';

export const neighborSchema = z.object({
  annotationUrl: urlSchema.nullable(),
  pageNumber: z.number(),
  similarity: z.number(),
});

export const neighborsPageSchema = z.object({
  pageNumber: z.number(),
  neighbors: z.array(neighborSchema),
});

export const neighborsResponseSchema = z.object({
  pages: z.array(neighborsPageSchema),
});
